import layout from '@/layout'

export default {
  path: '/salary',
  component: layout,
  redirect: '/salary/index',
  name: 'salary_indexs',
  meta: {
    title: '人力',
    icon: 'salary'
  },
  children: [
    {
      path: '/salary/index',
      name: 'salary_index',
      component: () => import('@/views/salary/index'),
      meta: {
        title: '职工待遇规划',
        icon: 'salary'
      }
    },
    {
      path: '/salary/salary_sheet',
      name: 'salary_sheet_index',
      component: () => import('@/views/salary_sheet/index'),
      meta: {
        title: '工资条',
        icon: 'salary'
      }
    },
    {
      path: '/salary/finance',
      name: 'salary_sheet_finance',
      component: () => import('@/views/finance/index'),
      meta: {
        title: '财务',
        icon: 'salary'
      }
    },
    {
      path: '/salary/worker_report',
      name: 'salary_worker_report',
      component: () => import('@/views/worker_report/index'),
      meta: {
        title: '工作汇报',
        icon: 'salary'
      }
    },
    {
      path: '/salary/worker_fix',
      name: 'salary_worker_fix',
      component: () => import('@/views/worker_fix/index'),
      meta: {
        title: '报修',
        icon: 'salary'
      }
    },
    {
      path: '/salary/worker_sale',
      name: 'salary_worker_sale',
      component: () => import('@/views/worker_sale/index'),
      meta: {
        title: '营业额汇报',
        icon: 'salary'
      }
    },
    {
      path: '/salary/worker_study_file',
      name: 'salary_worker_study_file',
      component: () => import('@/views/worker_study_file/index'),
      meta: {
        title: '员工学习',
        icon: 'salary'
      }
    },
    {
      path: '/salary/worker_agreement',
      name: 'salary_worker_agreement',
      component: () => import('@/views/worker_agreement/index'),
      meta: {
        title: '劳动合同',
        icon: 'salary'
      }
    }
  ]
}
